import "core-js/modules/es6.regexp.replace";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import { mapGetters } from 'vuex';
import { buildProductAlternates } from '~/helpers/seo-helpers';
export default {
  name: 'ProductSeo',
  props: {
    product: {
      type: Object,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    baseURL: 'request/baseURL'
  }), {
    description() {
      const currentDescription = this.product.description.main ? this.product.description.main.replace(/\n|\r|\t|<(?:.|\n)*?>/gm, '').slice(0, 150) : '';
      return this.product.additionalInformation.metaDescription || currentDescription;
    },

    canonical() {
      const canonical = {
        rel: 'canonical',
        href: this.url
      };
      return canonical;
    }

  }),

  head() {
    const hasIncorrectRedirect = this.product.redirection && this.product.redirection.redirectUrl === '#';
    return {
      title: "".concat(this.product.name, " ").concat(this.product.line, " | Maisons du Monde"),
      meta: [{
        name: 'description',
        content: this.description
      }, hasIncorrectRedirect ? {
        hid: 'robots',
        name: 'robots',
        content: 'noindex'
      } : {}],
      link: [this.canonical, ...buildProductAlternates(this.baseURL, this.product.additionalInformation.seo.alternates, this.product.reference)]
    };
  },

  render: h => h(null)
};